import { Routes, Route, BrowserRouter } from "react-router-dom";
import { SpeedInsights } from '@vercel/speed-insights/react';

import './assets/css/styles.css';

import Home from './views/Home.jsx';
import Contacto from './views/Contacto.jsx';
import Flotas from './views/Flotas.jsx';
import Particulares from './views/Particulares.jsx';
import Nosotros from './views/Nosotros.jsx';

function App() {
  return (
    <BrowserRouter>
      <SpeedInsights />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/contacto' element={<Contacto />} />
        <Route path='/nosotros' element={<Nosotros />} />
        <Route path='/flotas' element={<Flotas />} />
        <Route path='/particulares' element={<Particulares />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;